import React, { useEffect } from 'react'
import { Box, Grid, CircularProgress, Pagination } from '@mui/material'

import AppNav from '../../components/appNav';
import TableInfo from '../../components/TableInfo';

import { api, baseURL } from '../../services/api'


export default function Documents() {
    const [loading, setLoading] = React.useState(false);
    const [listFiles, setListFiles] = React.useState([])
    const [page, setPage] = React.useState(1);
    const [pageCount, setPageCount] = React.useState(1);
    const pageSize = 10;

    const columns = [
        { Header: "#", accessor: "icon", width: "100%" },
        { Header: "Certidão", accessor: "title", width: "100%" },
        { Header: "Baixar", accessor: "actions", width: "90%" },
    ];
    async function handleView({ id }) {
        try {
            const link = listFiles.find(file => id == file.id)?.attributes?.link;
            if (link) {
                window.open(link, '_blank');
                return;
            }
            const [files] = listFiles.filter(file => id == file.id)
            if (files.attributes?.file?.data?.attributes?.url !== null) {
                window.open(`${baseURL + files.attributes.file.data.attributes.url}`, '_blank');
            }
        } catch (error) {
            console.log(error)
            alert(error.message)
        }
    }
    async function handleFiles(pageNumber = 1) {
        try {
            const files = await api.get(`/documents?populate=*&pagination[page]=${pageNumber}&pagination[pageSize]=${pageSize}`);
            if (files.status === 200) {
                setListFiles(files.data.data);
                setPage(files.data.meta.pagination.page);
                setPageCount(files.data.meta.pagination.pageCount);
                setLoading(false);
            }
        } catch (error) {
            alert(error?.message)
            setLoading(false)
        }
    }
    useEffect(() => { handleFiles(1) }, [])
    return (
        <Box sx={{ width: "100vw", height: "100vh", px: 0, m: 0 }}>
            <AppNav />
            <Grid container my={12} sx={{ justifyContent: 'center' }}>
                <Grid item sm={6} >
                    {loading ?
                        <Box sx={{ width: '100%', height: '10vh', display: 'flex', justifyContent: 'center' }}>
                            <CircularProgress sx={{ alignSelf: 'center' }} size={50} />
                        </Box>
                        :
                        <>
                            <TableInfo title='Certidões' variant="secondary" view={handleView} rows={listFiles} columns={columns} />
                            <Grid container justifyContent="center" sx={{ my: 4 }}>
                                <Pagination
                                    count={pageCount}
                                    page={page}
                                    onChange={(e, value) => {
                                        setPage(value)
                                        handleFiles(value)
                                    }
                                    }
                                    color="primary"
                                />
                            </Grid>
                        </>
                    }
                </Grid>
            </Grid>
        </Box>
    )
}